import { observer } from 'mobx-react';
import TeamDesktop from './desktop/TeamDesktop';
import { useEffect } from 'react';

const Team = observer(() => {
  useEffect(() => {
    document.title = `transact.digital GmbH - Team`;
  }, []);

  return <TeamDesktop />;
});

export default Team;
